// extracted by mini-css-extract-plugin
module.exports = {"basicEditor":"BasicEditor_basicEditor__s7e0L","basicEditorSkeleton":"BasicEditor_basicEditorSkeleton__bq_b5"};